import Loader from "react-loaders"
import AnimatedLetters from "../AnimatedLetters"
import "./index.scss"
import { useEffect, useRef, useState } from "react"
import emailjs from "@emailjs/browser"
import L from "leaflet"
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import markerIcon from "leaflet/dist/images/marker-icon.png"
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png"
import markerShadow from "leaflet/dist/images/marker-shadow.png"

const contactMarkerIcon = L.icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
})

const CONTACT_EMAILJS_CONFIG = {
  serviceId: (
    process.env.REACT_APP_EMAILJS_CONTACT_SERVICE_ID ||
    process.env.REACT_APP_EMAILJS_SERVICE_ID ||
    ""
  ).trim(),
  templateId: (process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID || "").trim(),
  publicKey: (
    process.env.REACT_APP_EMAILJS_CONTACT_PUBLIC_KEY ||
    process.env.REACT_APP_EMAILJS_PUBLIC_KEY ||
    ""
  ).trim(),
}

const getMissingContactConfigKeys = () => {
  const missingKeys = []

  if (!CONTACT_EMAILJS_CONFIG.serviceId) {
    missingKeys.push(
      "REACT_APP_EMAILJS_CONTACT_SERVICE_ID or REACT_APP_EMAILJS_SERVICE_ID"
    )
  }

  if (!CONTACT_EMAILJS_CONFIG.templateId) {
    missingKeys.push("REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID")
  }

  if (!CONTACT_EMAILJS_CONFIG.publicKey) {
    missingKeys.push(
      "REACT_APP_EMAILJS_CONTACT_PUBLIC_KEY or REACT_APP_EMAILJS_PUBLIC_KEY"
    )
  }

  return missingKeys
}

const extractEmailJsErrorMessage = (errorReason) => {
  if (!errorReason) {
    return "Erreur inconnue"
  }

  if (typeof errorReason === "string") {
    return errorReason.trim() || "Erreur inconnue"
  }

  if (typeof errorReason.status === "number") {
    const statusText =
      typeof errorReason.text === "string" && errorReason.text.trim()
        ? errorReason.text.trim()
        : "Erreur inconnue"

    return `HTTP ${errorReason.status}: ${statusText}`
  }

  if (typeof errorReason.text === "string" && errorReason.text.trim()) {
    return errorReason.text
  }

  if (typeof errorReason.message === "string" && errorReason.message.trim()) {
    return errorReason.message
  }

  return "Erreur inconnue"
}

const Contact = () => {
  const refForm = useRef()

  const [letterClass, setLetterClass] = useState("text-animate")
  const [isSending, setIsSending] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover")
    }, 3000) //animation 3s
  }, [])

  const sendEmail = async (e) => {
    e.preventDefault()

    if (isSending) {
      return
    }

    const missingConfigKeys = getMissingContactConfigKeys()
    if (missingConfigKeys.length > 0) {
      toast.error(
        `Envoi indisponible: configuration EmailJS incomplète (${missingConfigKeys.join(", ")}).`
      )
      return
    }

    setIsSending(true)

    try {
      await emailjs.sendForm(
        CONTACT_EMAILJS_CONFIG.serviceId,
        CONTACT_EMAILJS_CONFIG.templateId,
        refForm.current,
        CONTACT_EMAILJS_CONFIG.publicKey
      )

      toast.success("Message envoyé avec succès !")
      refForm.current?.reset()
    } catch (error) {
      toast.error(
        `Echec de l'envoi du message. ${extractEmailJsErrorMessage(error)}`
      )
    } finally {
      setIsSending(false)
    }
  }

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={[
                "M",
                "e",
                " ",
                "C",
                "o",
                "n",
                "t",
                "a",
                "c",
                "t",
                "e",
                "r",
              ]}
              index={15}
            />
          </h1>
          <p>
            Naturellement je suis intéressé par tous les domaines qui touchent
            la technologie. Je suis très ouvert et prêt à relever de nouveaux
            défis. N'hésitez surtout pas à me contacter pour vos ambitieux
            projets via ce formulaire ci-dessous :
          </p>
          <div className="contact-form">
            <form ref={refForm} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input
                    type="text"
                    name="name"
                    placeholder="Votre Prénom & Nom : "
                    required
                  />
                </li>
                <li className="half">
                  <input
                    type="email"
                    name="email"
                    placeholder="Votre Email :"
                    required
                  />
                </li>
                <li>
                  <input
                    type="text"
                    name="subject"
                    placeholder="Sujet : "
                    required
                  />
                </li>
                <li>
                  <textarea
                    name="message"
                    placeholder="Votre message : ..."
                    required
                  ></textarea>
                </li>
                <li>
                  <input
                    type="submit"
                    className="btn-envoyer"
                    value={isSending ? "Envoi en cours..." : "Envoyer"}
                    disabled={isSending}
                  />
                </li>
              </ul>
            </form>
          </div>
        </div>
      </div>
      <div className="info-map">
        Souleymane DIALLO,
        <br />
        <span className="profil">Fullstack Developer,</span>
        <br />
        Dakar, Sénégal <b />
        <span className="email">sdley2020@gmail.com</span>
      </div>
      <div className="enveloppe-map">
        <MapContainer
          center={[14.742376052593402, -17.275769067723655]}
          zoom={12}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker
            position={[14.742376052593402, -17.275769067723655]}
            icon={contactMarkerIcon}
          >
            <Popup>
              Souleymane habite ici ! Il serait très heureux de vous voir lui
              rendre visite...
            </Popup>
          </Marker>
        </MapContainer>
      </div>
      <Loader type="pacman" />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
    </>
  )
}

export default Contact
